export const SET_REPAIR_SERVICES = 'SET_REPAIR_SERVICES';
export const CLEAR_SERVICES = 'CLEAR_SERVICES';
export const ADD_REPAIR_NOTES = 'ADD_REPAIR_NOTES';



// WEBPACK FOOTER //
// ./src/store/reducers/repair/actionTypes.js